// extracted by mini-css-extract-plugin
export default {"select":"select_select__JCv4S","error":"select_error__qUgp0"};